'use client'

import { Heading } from '@circlefin/components/lib/Heading'

export const CWHeading = Heading
export const CWHeadingHeader = Heading.Header
export const CWHeadingIntro = Heading.Intro
export const CWHeadingEyebrow = Heading.Eyebrow
